// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";
import { ActivityList } from "@src/features/activity/components/ActivityList";

export default function ActivityScreen() {
  return (
    <WebLayout>
      <ActivityList />
    </WebLayout>
  );
}
